import { render, staticRenderFns } from "./PermissionRecordListing.vue?vue&type=template&id=1c9e1caf&scoped=true"
import script from "./PermissionRecordListing.vue?vue&type=script&lang=js"
export * from "./PermissionRecordListing.vue?vue&type=script&lang=js"
import style0 from "./PermissionRecordListing.vue?vue&type=style&index=0&id=1c9e1caf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9e1caf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c9e1caf')) {
      api.createRecord('1c9e1caf', component.options)
    } else {
      api.reload('1c9e1caf', component.options)
    }
    module.hot.accept("./PermissionRecordListing.vue?vue&type=template&id=1c9e1caf&scoped=true", function () {
      api.rerender('1c9e1caf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/permissionrecord/PermissionRecordListing.vue"
export default component.exports